var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"curr-op",staticStyle:{"width":"100%"}},[_c('BaseTime',{staticClass:"m-auto",attrs:{"curr_operation":_vm.curr_operation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }